/**
 * Maps AI route keys (e.g. "trainer.viewSchedule") and path-like strings to real app paths.
 * @param {string} input - Route key or path (e.g. "trainer.plan" or "trainer/sessions")
 * @returns {{ ok: true, path: string } | { ok: false, reason: string }}
 */
const ROUTE_KEY_MAP = {
  "trainer.viewSchedule": "/trainer/sessions",
  "trainer.sessions": "/trainer/sessions",
  "trainer.sessionList": "/trainer/sessions",
  "trainer.plan": "/trainer/lesson-plans",
  "trainer.lessonPlans": "/trainer/lesson-plans",
  "trainer.lessons": "/trainer/lesson-plans",
  "trainer.drills": "/trainer/drills",
  "trainer.students": "/trainer/students",
  "trainer.billing": "/trainer/billing",
  "trainer.settings": "/trainer/settings",
  "trainer.home": "/trainer",
  "trainer.dashboard": "/trainer",
  "home": "/",
  "apps": "/",
};

export function resolveAiRoute(input) {
  const raw = typeof input === "string" ? input.trim() : "";
  if (!raw) {
    return { ok: false, reason: "empty" };
  }
  if (raw.startsWith("/")) {
    return { ok: true, path: raw };
  }
  if (raw.includes("/")) {
    return { ok: true, path: "/" + raw };
  }
  const path = ROUTE_KEY_MAP[raw];
  if (path !== undefined) {
    return { ok: true, path };
  }
  return { ok: false, reason: "unknown route key: " + raw };
}
